// Legacy rows were written in Chinese; new rows are English. Both render in the UI language.
export function normalizeAmounts(s) {
  return s.replace(/＄([\d.]+) 额度/g, '$$$1').replace(/(\d+) 点额度/g, '$1 quota');
}

const PATTERNS = [
  { re: /^(?:倍率：|Ratio: )([\d.]+) × ([\d.]+) × ([\d.]+)$/, key: 'ratio3', args: ['a', 'b', 'c'] },
  { re: /^(?:倍率：|Ratio: )([\d.]+) × ([\d.]+)$/, key: 'ratio2', args: ['a', 'b'] },
  { re: /^(?:渠道 (.+?) 测试成功，响应：|Channel (.+?) test succeeded, response: )([\s\S]*)$/, key: 'channel_test_ok', args: ['name', 'detail'] },
  { re: /^(?:渠道 (.+?) 测试失败，错误：|Channel (.+?) test failed, error: )([\s\S]*)$/, key: 'channel_test_fail', args: ['name', 'detail'] },
  { re: /^(?:管理员将用户额度从 (.+?)修改为 |Admin changed user quota from (.+?) to )(.+)$/, key: 'admin_quota', args: ['from', 'to'] },
  { re: /^(?:通过 API 充值 |Top-up via API: )(.+)$/, key: 'topup_api', args: ['amount'] },
  { re: /^(?:通过兑换码充值 |Top-up via redemption code: )(.+)$/, key: 'topup_code', args: ['amount'] },
  { re: /^(?:新用户注册赠送 |New user sign-up bonus: )(.+)$/, key: 'signup_bonus', args: ['amount'] },
  { re: /^(?:使用邀请码赠送 |Invite code bonus: )(.+)$/, key: 'invitee_bonus', args: ['amount'] },
  { re: /^(?:邀请用户赠送 |Referral bonus: )(.+)$/, key: 'inviter_bonus', args: ['amount'] },
];

export function localizeLogContent(content, t) {
  if (!content) return content;
  const s = normalizeAmounts(content);
  for (const { re, key, args } of PATTERNS) {
    const m = s.match(re);
    if (!m) continue;
    // alternation groups: take the first defined capture for each argument, in order
    const values = m.slice(1).filter((v) => v !== undefined);
    const params = {};
    args.forEach((name, i) => { params[name] = values[i]; });
    return t('log.content.' + key, params);
  }
  return s;
}
